@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3 style="margin-top: 18px; line-height: 1.2;" i18n>Booking List for period: <br><span style="font-size: 18px; font-weight: normal; color: #666;">(Created Date)</span></h3>
    <div style="width: calc(100vw - 607px); float: left; margin-left: 304px; margin-bottom:20px;margin-top:-71px;">
      <div style="float:left; width: 200px;margin-right: 20px;">
        <span>From Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 200px;">
        <span>To Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 400px;margin-left:24px;">
        <span>Tags:</span><br>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" style="float:left;">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
        <div style="width:180px; float:left;margin-top:-16px;">
          <div style="float:left; width: 90px;">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" style="background-color: #22C55E;border-color: #22C55E;margin-left: 12px;" (click)="doneDate()">
              Go
            </button>
          </div>
          <div style="float:left; width: 90px;margin-top:16px;">
            @if (ListBookings) {
              <button
                type="button"
                pButton
                pRipple
                (click)="ListBookingsTable.exportCSV()"
                class="mr-2"
                pTooltip="Export to CSV"
                tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table  #ListBookingsTable
          [columns]="cols"
          [value]="ListBookings"
          responsiveLayout="scroll">
          <ng-template #header let-columns>
            <th width="8%">Sales ID
            </th>
            <th  width="10%">Start Date
            </th>
            <th width="8%">Start
            </th>
            <th width="8%">Name
            </th>
            <th  width="15%">Package
            </th>
            <th style="text-align: left;" width="20%">Admissions
            </th>
            <th style="text-align: center;" width="6%">Guests
            </th>
            <th style="text-align: center;"  width="5%">Total
            </th>
            <th style="text-align: center;"  width="5%">O/S
            </th>
            <th width="20%">
              Extras
            </th>
            <th width="5%">
              Allergy
            </th>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              <td>{{rowData.bookingIdHR}}</td>
              <td>{{rowData.startTime | date:'dd/MM/yy'}}</td>
              <td>{{rowData.startTime | date:'HH:mm' : 'UTC'}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.packageName}}</td>
              <td>{{rowData.admissions}}</td>
              <td style="text-align: right;">{{rowData.guests}}</td>
              <td style="text-align: right;">{{rowData.total | currency: (rowData.currency || CurrencySymbol)}}</td>
              @if (rowData.outstanding <=0) {
                <td style="text-align: right;">{{rowData.outstanding | currency: (rowData.currency || CurrencySymbol)}}</td>
              }
              @if (rowData.outstanding >0) {
                <td style="text-align: right;"><span style="color: Red; font-weight: bold;">{{rowData.outstanding | currency: (rowData.currency || CurrencySymbol)}}</span></td>
              }
              <td>{{rowData.extraslist}}</td>
              <td>{{rowData.allergy}}</td>
            </tr>
          </ng-template>
          <ng-template  #footer>
            @if (ListBookings.length > 0 && ListBookings != null) {
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style="text-align: right;">
                  <b>{{guests}}</b>
                  <td style="text-align: right;">
                    <b>{{total | currency: CurrencySymbol}}</b>
                  </td>
                  <td style="text-align: right;">
                    <b>{{outstanding | currency: CurrencySymbol}}</b>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              }
              @if (ListBookings.length == 0 || ListBookings == null) {
                <tr>
                  <td style="text-align: center;" colspan="8">
                    There is no data for the selected date range.
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>
        </div>
      </div>
    }
